/**
 * What the account's "Fetch posts" switch (`fetchPosts`) does on each
 * platform. A platform missing from here has nothing that reads the switch,
 * so it isn't offered.
 */
const EXPLANATIONS = new Map<string, string>([
    [
        'instagram',
        "Collects this profile's posts within How long we collect a post, and records Instagram's comment count on each, so the comment backstop can tell which posts have new comments. On for every authorised Instagram profile unless there's a reason to leave one out."
    ],
    [
        'twitter',
        "Collects this profile's root posts from the X API with each post's reply count at its first read, and links the replies Arwen holds to them. On for every X profile from when it's added. Each new post is one billable read."
    ]
])

/**
 * What the switch does on `platform` (a social media service short name), or
 * `undefined` where nothing reads it and the switch should be hidden.
 */
export function fetchPostsExplanation(platform: string | null | undefined): string | undefined {
    return platform ? EXPLANATIONS.get(platform.toLowerCase()) : undefined
}
